let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g0XZO")).then(() => parcelRequire('6Xm0L'));